// const mjPopupBtns = document.querySelectorAll('.mj-popup--trigger');


// mjPopupBtns.forEach((btn) => {
//     btn.addEventListener('click', (event) => {
//         // var popupID = event.currentTarget.id.substring(triggerPrefix.length);
//         var popupID = event.currentTarget.getAttribute('data-trigger');
//         // Use jQuery to find the closest ancestor with class 'mj-popup__hide'
//         var popupSelector = jQuery('#' + popupID).closest('.jupiterx-popup')[0];

//         console.log(popupSelector);
//         if (popupSelector) {
//             // Use jQuery to manipulate the classes
//             jQuery(popupSelector).removeClass('mj-popup__hide');
//             jQuery(popupSelector).removeClass('jupiterx-popup--hide-state');
//             jQuery(popupSelector).addClass('jupiterx-popup--show-state');
//         } else {
//             console.error("Popup element not found!");
//         }
//     });
// });

// Check and add event listener for the Sign In button
const signinBtn = document.getElementById('popup-login__signin-btn');
if (signinBtn) {
    signinBtn.addEventListener('click', function (event) {
        event.preventDefault();
        document.getElementById('popup-login__main').classList.remove('show');
        document.getElementById('popup-login__forget').classList.remove('show');
        document.getElementById('popup-login__signin').classList.add('show');
    });
}

// Check and add event listener for the Sign Up button
const signupBtn = document.getElementById('popup-login__signup-btn');
if (signupBtn) {
    signupBtn.addEventListener('click', function (event) {
        event.preventDefault();
        document.getElementById('popup-login__main').classList.remove('show');
        document.getElementById('popup-login__forget').classList.remove('show');
        document.getElementById('popup-login__role').classList.add('show');
    });
}

// Check and add event listener for the Login button
const loginBtn = document.getElementById('popup-login__login-btn');
if (loginBtn) {
    loginBtn.addEventListener('click', function (event) {
        event.preventDefault();
        document.getElementById('popup-login__signin').classList.remove('show');
        document.getElementById('popup-login__forget').classList.remove('show');
        document.getElementById('popup-login__main').classList.add('show');
    });
}

// Check and add event listener for the Back button in the role section
const backBtnRole = document.getElementById('popup-btn-back');
if (backBtnRole) {
    backBtnRole.addEventListener('click', function (event) {
        event.preventDefault();
        document.getElementById('popup-login__signin').classList.remove('show');
        document.getElementById('popup-login__role').classList.remove('show');
        document.getElementById('popup-login__forget').classList.remove('show');
        document.getElementById('popup-login__main').classList.add('show');
    });
}

// Check and add event listener for the Back button in the main section
const backBtnMain = document.getElementById('popup-login-btn-back');
if (backBtnMain) {
    backBtnMain.addEventListener('click', function (event) {
        event.preventDefault();
        document.getElementById('popup-login__role').classList.remove('show');
        document.getElementById('popup-login__main').classList.remove('show');
        document.getElementById('popup-login__forget').classList.remove('show');
        document.getElementById('popup-login__signin').classList.add('show');
    });
}

// Check and add event listener for the Forgot Password label
const forgotPassLabel = document.querySelector('.forgot-pass-label');
if (forgotPassLabel) {
    forgotPassLabel.addEventListener('click', function (event) {
        event.preventDefault();
        document.getElementById('popup-login__signin').classList.remove('show');
        document.getElementById('popup-login__role').classList.remove('show');
        document.getElementById('popup-login__main').classList.remove('show');
        document.getElementById('popup-login__forget').classList.add('show');
    });
}


document.addEventListener('DOMContentLoaded', function () {

    // Select all elements with the class 'mj-popup--trigger'
    const mjPopupBtns = document.querySelectorAll('.mj-ajax-popup--trigger');

    mjPopupBtns.forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.preventDefault();

            // Extract the popup ID from the data-id attribute by removing the 'trigger__' prefix
            // const triggerPrefix = 'trigger__';
            const popupID = event.currentTarget.getAttribute('data-id');

            // Find the closest ancestor with class 'jupiterx-popup' using jQuery
            const popupElement = jQuery('#' + popupID).closest('.jupiterx-popup')[0];

            if (popupElement) {
                // Collect payment details from data attributes
                const paymentDetails = {
                };

                // Get the necessary elements
                var selectedItemsInput = document.querySelector('#wishlist-selected-items-ids');
                var selectedEnquiryType = document.querySelector('#wishlist-type');
                var popupFormItemsCountInput = jQuery("#enquiry-items");
                var popupItemTypeNameElements = jQuery(".selected-type-name");
                var popupEnquiryFormType = jQuery("#mj-form__enquire-type");
                var popupEnquiryItems = jQuery("#mj-form__enquire-post");
                const eventTypeContainer = document.getElementById('event-type-container');
                const serviceTypeContainer = document.getElementById('service-type-container');

                // Check if the required elements exist before proceeding
                if (selectedItemsInput && selectedEnquiryType && popupFormItemsCountInput.length && popupEnquiryFormType.length && popupEnquiryItems.length) {

                    // Get and split the value of the hidden input into an array
                    var selectedItemsArray = selectedItemsInput.value ? selectedItemsInput.value.split(',') : [];

                    // Count the number of items
                    var selectedItemsCount = selectedItemsArray.length;

                    // Set the content or value of the input fields
                    popupFormItemsCountInput.text(selectedItemsCount);
                    popupEnquiryFormType.val(selectedEnquiryType.value);
                    popupEnquiryItems.val(selectedItemsInput.value);

                    popupItemTypeNameElements.each(function () {
                        if (selectedEnquiryType.value === 'venue') {
                            eventTypeContainer.classList.add('active');
                            serviceTypeContainer.classList.remove('active');
                        } else if (selectedEnquiryType.value === 'supplier') {
                            serviceTypeContainer.classList.add('active');
                            eventTypeContainer.classList.remove('active');
                        } else {
                            eventTypeContainer.classList.remove('active');
                            serviceTypeContainer.classList.remove('active');
                        }
                        jQuery(this).text(selectedEnquiryType.value);
                    });

                } else {
                    // console.error("One or more required elements are missing: #wishlist-selected-items-ids, #wishlist-type, #enquiry-items, #mj-form__enquire-type, or #mj-form__enquire-post");
                }
                // console.error("Element with ID 'wishlist-selected-items-ids' not found.");


                // const itemDetails = {
                //     itemType: event.currentTarget.getAttribute('data-type'),
                //     selectedIds: event.currentTarget.getAttribute('data-product-id'),
                // };

                // Show popup content using the collected payment details
                //showPopupAjaxContent(paymentDetails);

                // Manipulate classes to show the popup
                jQuery(popupElement).removeClass('mj-popup__hide jupiterx-popup--hide-state')
                    .addClass('jupiterx-popup--show-state');
            } else {
                console.error("Popup element not found!");
            }
        });
    });
});

function showPopupAjaxContent(paymentDetails) {
    const formData = {
        // product_id: paymentDetails.productId,
        // payment_method: paymentDetails.paymentMethod,
        // product_type: paymentDetails.productType,
        // return_url: paymentDetails.returnUrl,
        // payment_test: paymentDetails.paymentTest,
        action: 'show_enquire_popup'
    };

    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: missjones_data.ajax_url,
        data: formData,
        cache: false,
        beforeSend: function () {
            // Optional: Add preloading animation or disable form submission button
        },
        success: function (data) {
            console.log("yes");
            $('#amz-ajax-popup-content').html(data);
            runPopupMethods();

            const paymentData = {
                productId: paymentDetails.productId,
                productType: paymentDetails.productType,
                paymentMethod: paymentDetails.paymentMethod,
                returnUrl: paymentDetails.returnUrl,
                paymentTest: paymentDetails.paymentTest
            };

            if (paymentDetails.paymentMethod === "stripe") {
                loadStripePayment(paymentData);
            } else if (paymentDetails.paymentMethod === "zarinpal") {
                loadZarinpalPayment(paymentData);
            }
        },
        error: function (data) {
            console.error(data);
            showNotification("Error!", "error");
        }
    });
}
